import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import admGrades from "../../views/app/modules/custom/admGrades"

const qualifications = "AD,A,A,B,B,C,C,C,C";
const qualificationsList = qualifications.split(',').map(e => e = {value: e, label: e})

export default (context) => {
  return {

    config: {
      pageSize: 40,
      remapRow: (form) => {
        form.owner = form.owner.label
        return form
      }
    },

    actions: {
      create: { reloadGrid: true },
      edit: {
        reloadGrid: true
      },
      delete: true,
      print: true,
      export: true,
      search: true
    },

    extras: {
      items: context.props.userAdmin.role === '100' ? 
      [
        {
          id: 0, name: 'Habilitar ingreso de notas', onClick: (row, ctx) => {
            if (ctx.state.formFilter.periodId === '0') {
              NotificationManager.success('Por favor seleccionar el periodo', 'Habilitar ingreso de notas', 5000, null, null, 'outline');
              return
            }
            ctx.showDialog({
              title: 'Habilitar ingreso de notas',
              msg: '¿Confirmar?',
              action: (ok) => {
                if (ok) {
                  context.props.setLoader(true)
                  _axios.post('admSubject/bulkedit?periodId=' + ctx.state.formFilter.periodId, { canEnterEval: true })
                    .then(r => {
                      NotificationManager.success(r.msg, 'Habilitar ingreso de notas', 5000, null, null, 'outline')
                      context.props.setLoader(false)
                    })
                }
              }
            })
          }
        },
        {
          id: 1, name: 'Inhabilitar ingreso de notas', onClick: (row, ctx) => {
            if (ctx.state.formFilter.periodId === '0') {
              NotificationManager.success('Por favor seleccionar el periodo', 'Inhabilitar ingreso de notas', 5000, null, null, 'outline');
              return
            }
            ctx.showDialog({
              title: 'Inhabilitar ingreso de notas',
              msg: '¿Confirmar?',
              action: (ok) => {
                if (ok) {
                  context.props.setLoader(true)
                  _axios.post('admSubject/bulkedit?periodId=' + ctx.state.formFilter.periodId, { canEnterEval: false })
                    .then(r => {
                      NotificationManager.success(r.msg, 'Inhabilitar ingreso de notas', 5000, null, null, 'outline')
                      context.props.setLoader(false)
                    })
                }
              }
            })
          }
        },
        // {
        //   id: 2, name: 'Clonar cursos en nuevo periodo', onClick: (row, ctx) => {

        //     if (ctx.state.formFilter.periodId === '0') {
        //       NotificationManager.primary('Por favor seleccionar el periodo del cual se clonará los cursos', 'Clonar cursos en nuevo periodo', 5000, null, null, 'outline');
        //       return
        //     }

        //     ctx.showDialog({
        //       title: 'Clonar cursos en nuevo periodo',
        //       msg: 'Se creará un nuevo periodo y se clonará los cursos existentes en periodo ' + ctx.state.formFilter.periodId + '. ¿Confirmar?',
        //       action: (ok) => {

        //         if (ok) {
        //           context.props.setLoader(true)
        //           _axios.post('admSubject/duplicate?periodId=' + ctx.state.formFilter.periodId)
        //             .then(r => {
        //               NotificationManager.primary(r.msg, 'Clonar cursos en nuevo periodo', 5000, null, null, 'outline')
        //               context.props.setLoader(false)
        //               ctx.setState({ formFilter: { periodId: r.data.periodId } })
        //               ctx.listenBtnActionsFormFilter('filter');
        //             })
        //             .catch(e => {
        //               NotificationManager.primary('Ocurrió un error', 'Clonar cursos en nuevo periodo', 5000, null, null, 'outline')
        //               context.props.setLoader(false)
        //             })
        //         }
        //       }
        //     })
        //   }
        //}
      ] : [],
      itemsInRowsTable: [
        {
          icon: 'simple-icon-note', name: 'Ingresar notas', onClick: (rowData, ctx) => {
            let obj = {
              module: 'admGrades',
              params: [
                { value: rowData.gradeId, label: rowData.grade },
                { value: rowData.ID, label: rowData.name }
              ],
              type: 0,
              keepFilters: false
            }
            ctx.props.setDeeplink(obj, ctx.props.history)
          }
        },
        {
          icon: 'simple-icon-note',
          name: 'Importar notas',
          onClick: (rowData, ctx) => {
            context.state.formFlags={ activityId: rowData.ID, sectionId: rowData.gradeId }
          },
          form: {
            name: 'Importar notas',
            remapGET: () => {
               return { activityId: context.state.formFlags.activityId, sectionId: context.state.formFlags.sectionId  }
            },
            postUrlF: (ctx) => {
              return 'admGrades/import';
            },
            okMsg: 'Se han importando las notas!',
            fields: [
              {
                name: "activityId",
                value: 0,
                type: "hidden"
              },
              {
                name: "superSectionId",
                value: 0,
                type: "hidden"
              },
              {
                col: 12,
                name: "l1",
                value: "Se importará las notas ingresadas en el siguiente file (<a target='_blank' href='/tplMails/dwn/GradesImport.xlsx'><b>descargar</b></a>). El archivo deberá ser guardado como CSV.",
                type: "label"
              },
              {rules:"required", col: 12, name: "sectionId", value: "", type: "select", label: "Sección", opts: { style: 'float-label', path: (c) => { return "/admSection/get?pick=true&parentId=" + context.state.formFlags.sectionId } }},

              {
                col: 12,
                name: "l2",
                value: "Especificar un máximo de 10 Conceptos de Evaluación a ingresar via Excel. Cada uno deberá ser ingresado en una columna. Ej: Para el Concepto 1 usará la columna C1",
                type: "label"
              },
              { rules:"required", col: 4, name: "c1", value: "", type: "select", label: "Concepto 1", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c2", value: "", type: "select", label: "Concepto 2", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c3", value: "", type: "select", label: "Concepto 3", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c4", value: "", type: "select", label: "Concepto 4", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c5", value: "", type: "select", label: "Concepto 5", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c6", value: "", type: "select", label: "Concepto 6", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c7", value: "", type: "select", label: "Concepto 7", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c8", value: "", type: "select", label: "Concepto 8", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c9", value: "", type: "select", label: "Concepto 9", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              { col: 4, name: "c10", value: "", type: "select", label: "Concepto 10", opts: { style: 'float-label', path: (c) => { return "/admEvalConcept/get?pick=true&activityId=" + context.state.formFlags.activityId } }},
              {
                col: 12,
                name: "csvfile",
                value: "",
                type: "dropzone",
                label: "Archivo CSV",
                opts: {
                  path: ()=> "admGrades/importAttach",
                  accept: '.csv'
                }
              }
            ],
            buttons: [
              {
                label: 'Cargar e importar notas',
                col: 12,
                isMain: true,
                onClick: (ctx) => { ctx.btnAction('save') }
              }
            ],
            onSuccess: (r) => { },
            onError: (e) => { }
          }
        }
      ]
    },

    filter: {
      fields: [
        {
          name: "periodId",
          value: { value: "0", label: "Actual" },
          type: "select",
          label: "Periodo",
          opts: {
            style: 'float-label',
            path: "/admPeriod/get?pick=true"
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "Grado",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return ctx.state.periodId || ctx.state.superSectionId },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.owner = { value: r.data.owner, label: r.data.ownerName }
          r.data.periodId = { value: r.data.periodId, label: r.data.periodName }
          r.data.categoryId = { value: r.data.categoryId, label: r.data.categoryName }
          // let ss = r.data.superSections
          // r.data.superSections = ss && ss.length > 0 ? { value: ss[0].ID, label: ss[0].name } : null
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (v.groups) {
          v.groups = v.groups.map(e => {
            e = { ID: e.value, name: e.label, selected: true }
            return e
          })
        }
        delete v.flags
        delete v.btn1
        delete v.btn2
        delete v.sections
        v.desc = ''
        return v
      },
      fields: [
        {
          col: 6,
          name: "periodId",
          value: "",
          type: "select",
          label: "Periodo",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admPeriod/get?pick=true"
          }
        },
        {
          col: 6,
          name: "categoryId",
          value: "",
          type: "select",
          label: "Categoría",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admCategory/get?type=aca&pick=true"
          }
        },
        {
          col: 12,
          name: "superSections",
          value: "",
          type: "select",
          label: "Grado(s)",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true",
            isMulti: true,
            setOutput: (v) => {
              if (v) return v.map((m) => { return { ID: m.value, name: m.label, selected: true } })
            }
          },
          disabled: () => { return context.state.idItemSelected ? true : false }
        },
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: "Nombre",
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "owner",
          value: "",
          type: "select",
          label: "Coordinador / responsable",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admStaff/get?pick=true"
          }
        },
        {
          col: 6,
          name: "type",
          value: 0,
          type: "select",
          label: "Tipo de evaluación",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {value: 0, label: "Cuantitativa"},
              {value: 1, label: "Cualitativa"}
            ],
            isClearable: false
          },
          disabled: () => { return context.state.idItemSelected ? true : false }
        },
        {
          col: 6,
          name: "qualifications",
          value: qualifications,
          type: "text",
          rules: ['required', {regex:'^([A-F+-]{1,2})(,[A-F+-]{1,2}){1,}?$'}],
          label: "Opciones de calificación cualitativa",
          hint: "Ingresar los caracteres cualitativos en orden de valor mayor a menor, separarlos por comas",
          opts: {
            style: 'float-label'            
          },
          renderIf: (ctx)=> ctx.state.type === 1,
          disabled: () => { return context.state.idItemSelected ? true : false }
        },
        {
          col: 6,
          name: "minToPass",
          value: "",
          type: "select",
          // rules: 'required|alpha|max:2',
          label: "Nota mínima para aprobar",
          opts: {
            style: 'float-label',
            items: qualificationsList,
            filterOption: admGrades.shortcut
          },
          renderIf: (ctx)=> ctx.state.type === 1
        },
        {
          col: 6,
          name: "minToPassNum",
          value: "",
          type: "number",
          rules: 'required|numeric|min:0,num|max:20,num',
          label: "Nota mínima para aprobar (numérico)",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx)=> ctx.state.type === 0
        },
        {
          col: 6,
          name: "calcAverage",
          value: true,
          type: "switch",
          label: "Promedia según sub conceptos",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => ctx.state.type === 0
        },
        {
          col: 4,
          name: "isAcademic",
          value: false,
          type: "switch",
          label: "Curso curricular",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "canEnterEval",
          value: false,
          type: "switch",
          label: "Permitir ingreso de notas",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "hasGrades",
          value: true,
          type: "switch",
          label: "Mostrar notas en app",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "hasBehavior",
          value: false,
          type: "switch",
          label: "Evaluar conducta",
          opts: {
            style: 'float-label'
          },
          disabled: (ctx) => { 
            return context.state.idItemSelected && ctx.state.hasBehavior 
          }
        },
        {col: 12,
          name: "spacer1",
          type: "spacer", 
        },
        {
          col: 8,
          name: "groups",
          value: "",
          type: "select",
          label: "Grupos asociados",
          opts: {
            style: 'float-label',
            path: "/admGroup/get?pick=true",
            isMulti: true,
            setOutput: v => v,
            remap: (r) => {
              if (r.data && r.data.Results) {
                r.data.Results = r.data.Results.map(g => ({
                  ID: g.ID,
                  name: g.name || g.Name || g.label || g.Label
                }))
              }
              return r
            }
          }
        },
        {
          col: 4,
          name: "btn3",
          value: null,
          type: "button",
          label: "Configurar grupos",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => { return context.state.idItemSelected },
          onClick: (ctx) => {
            ctx.toogleSubGrid(2)
          }
        },
        {
          col: 12,
          name: "btn1",
          value: null,
          type: "button",
          label: "Configurar secciones",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => { return context.state.idItemSelected },
          onClick: (ctx) => {
            ctx.toogleSubGrid(0)
          }
        },
        {
          col: 12,
          name: "btn2",
          value: null,
          type: "button",
          label: "Conceptos evaluación",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => { return context.state.idItemSelected },
          onClick: (ctx) => {
            ctx.toogleSubGrid(1)
          },
          modulePermissions: "admEvalConcept"
        }
      ],
      subGrids: [
        {
          name: (ctx) => { return 'Secciones curso: ' + ctx.state.name },
          module: 'admActivityParts',
          filterBy: () => { return { parentId: context.state.idItemSelected, sortBy: "name", desc: false} }
        },
        {
          name: (ctx) => { return 'Evaluaciones curso: ' + ctx.state.name },
          module: 'admEvalConcept',
          filterBy: () => { return { activityId: context.state.idItemSelected } }
        },
        {
          name: (ctx) => { return 'Grupos curso: ' + ctx.state.name },
          module: 'admActivityParts',
          filterBy: () => { return { parentId: context.state.idItemSelected, sortBy: "name", desc: false, byGroups: true} }
        },
      ]
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID"
      },
      {
        Header: "Nombre",
        accessor: "name"
      },
      {
        Header: "Grado",
        accessor: "grade"
      },
      {
        Header: "Nro. conceptos Ev.",
        accessor: "parts"
      },
      {
        Header: "Coordinador / responsable",
        accessor: "owner"
      }
    ]
  }
}